<li class="a-option-bar__item">
  @if(id$ | async; as id){
  <input
    type="radio"
    [id]="id"
    [name]="name$ | async"
    [checked]="checked$ | async"
    [disabled]="disabled$ | async"
    (click)="onClick()"
  />
  <label class="a-option-bar__option {{ type$ | async }}" [for]="id">
    <span class="a-option-bar__label">
      <ng-content></ng-content>
    </span>
  </label>
  }
</li>
